import {Component} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {ThemeService} from '../../services/theme.service';

import {BrandingLayoutService} from '../../services/branding-layout.service';
import {AnimatedContainerComponent} from '../animated-container/animated-container.component';

@Component({
    selector: 'app-animated-logo',
    templateUrl: './animated-logo.component.html',
    styleUrls: ['./animated-logo.component.scss'],
    imports: [TranslateModule, AnimatedContainerComponent]
})
export class AnimatedLogoComponent {

  public constructor(public themeService: ThemeService,
                     public brandingLayoutService: BrandingLayoutService) {
  }

}
